import type { SubtaskCategory } from "src/pages/projects/utils";
import { createContext, useContext } from "react";
import type { AmpWorkflowStatusFragment } from "src/graphql";
import type {
  ReviewFile,
  ReviewLinkedProject,
  ReviewTask,
} from "src/pages/projects/library/canvas/canvas-review";

export type CanvasReviewState = {
  tasks: Map<string, ReviewTask[]>;
  /** Projects linked to each file without a task. */
  projects: Map<string, ReviewLinkedProject[]>;
  isLoading: boolean;
  isBusy: boolean;
  error: Error | null;
  submit: (files: ReviewFile[], anchor: HTMLElement) => void;
  /** `onBack` reopens what the picker replaced, as the linked tasks it was opened from. */
  changeProject: (
    file: ReviewFile,
    task: ReviewTask,
    anchor: HTMLElement,
    onBack?: () => void,
  ) => void;
  link: (
    fileId: string,
    task: Pick<ReviewTask, "id" | "project_id">,
  ) => Promise<boolean>;
  setSubtaskStatus: (taskId: string, category: SubtaskCategory) => void;
  unlink: (fileId: string, taskId: string) => void;
  unlinkProject: (fileId: string, projectId: string) => void;
  setStatus: (taskId: string, statusId: string) => void;
  statuses: (workflowId: string) => AmpWorkflowStatusFragment[];
};

export const CanvasReviewContext = createContext<CanvasReviewState | null>(
  null,
);
export const useCanvasReview = () => useContext(CanvasReviewContext);
